export default __webpack_public_path__ + "static/media/thumbnail4.cc2f3ff9.jpg";